import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Provider } from '@hooks/MSTHook';
import { AppDefProvider } from '@lusha/mfe-app-ctx';
import { queryClient } from '@lusha/react-query';
import { theme, ThemeProvider } from '@lusha-ui/theme';
import { TooltipProvider } from '@lusha-ui/tooltip';
import { QueryClientProvider } from '@tanstack/react-query';
import makeInspectable from 'mobx-devtools-mst';
import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import rootStore from './models/RootStore';
import { store } from './reducers/store';
import { theme as themeOld } from './theme';
function AppContext(props) {
    const { children } = props;
    return (_jsx(AppDefProvider, { platform: 'plugin', subPlatform: 'plugin', children: _jsx(QueryClientProvider, { client: queryClient, children: _jsx(ReduxProvider, { store: store, children: _jsx(Provider, { value: makeInspectable(rootStore), children: _jsx(StyledThemeProvider, { theme: themeOld, children: _jsx(ThemeProvider, { theme: theme, children: _jsx(TooltipProvider, { children: children }) }) }) }) }) }) }));
}
export default AppContext;
